import styled from 'styled-components';
import {Pagination} from 'antd';

export const StyledPagination = styled(Pagination)`
  & {
    padding: 16px 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    color: rgba(92, 101, 110, 1);
    background-color: ${({theme}) => theme.palette.background.paper};
    overflow: visible;

    & li {
      margin-bottom: 4px;
      margin-top: 4px;
    }

    &.mini {
      & .ant-pagination-item,
      & .ant-pagination-prev,
      & .ant-pagination-next {
        margin-bottom: 4px;
        margin-top: 4px;
      }
    }
  }
  & .ant-pagination-options {
    display: flex;
    align-items: center;
    margin-left: auto;
  }
  & .ant-pagination-item {
    border-radius: 6px;
    border: 1px solid rgba(234, 236, 239, 1);
  }
  & .ant-pagination-item-link {
    line-height: 32px;
    text-align: center;
  }
  & .ant-pagination-item-link,
  & .ant-pagination-item > a {
    border-radius: 6px;
    background-color: ${({theme}) => theme.palette.background.paper};
    color: rgba(92, 101, 110, 1);
  }
  & .ant-pagination-item > a:hover {
    border: 1px solid ${({theme}) => theme.palette.secondary.main};
    background-color: ${({theme}) => theme.palette.secondary.main};
    color: #FFFFFF;
  }
  & .ant-pagination-item.ant-pagination-item-active {
    font-weight: 400;
    border: none;
    background-color: ${({theme}) => theme.palette.secondary.main};
    & > a {
      border: none;
      background-color: transparent;
      color: #FFFFFF;
      &:hover {
        color: #FFFFFF;
      }
    }
  }
`;
